import Heading from "@/components/atoms/Heading";
import HeroPill from "@/components/atoms/HeroPill";
import LeadGenerationInputs from "@/components/organisms/LeadGenerationInputs";
import React from "react";

type MarketingHeadingProps = {
  data: {
    type: string;
    heading: string;
    headingType: string;
    subheading: string;
    ctaText: string;
    leadEndpointUrl?: string;
    defaultCountry?: string;
    features: {
      icon: string;
      text: string;
    }[];
  };
};

const MarketingHeading: React.FC<MarketingHeadingProps> = ({ data }) => {
  return (
    <div className="container flex flex-col items-center justify-between gap-8 lg:flex-row">
      <div className="flex flex-col items-center lg:w-1/2">
        <div>
          {data?.subheading && (
            <HeroPill category={data?.subheading} className="mb-5" />
          )}
          <Heading
            heading={[{ text: data?.heading }]}
            as="h2"
            fontStyle="text-title-32 lg:text-title-48"
          />
          <div className="mt-6 flex flex-col gap-5 lg:mt-10 ">
            {data?.features.map((feature, index) => (
              <div className="flex items-center gap-3" key={index}>
                <div className="flex h-7 w-7 items-center justify-center rounded-lg border border-purple-3 bg-purple-0">
                  <img src={feature.icon} alt="feature-icon" />
                </div>
                <p className="text-body-16 text-grey-4">{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-full lg:w-1/2">
        <LeadGenerationInputs
          header // decides whether button is in same line as mobile input
          validateMobile
          fullForm // decides whether the form will contain name, email and mobile vs just email and mobile
          ctaText={data?.ctaText}
          defaultCountry={data?.defaultCountry}
          sourceSent="hero"
          scenesKey={data?.leadEndpointUrl}
        />
      </div>
    </div>
  );
};
export default MarketingHeading;
